var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarToolsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.03232 18.2287L11.713 12.2178C11.7601 12.1001 11.8308 11.9932 11.9205 11.9035C12.0102 11.8138 12.1172 11.7433 12.235 11.6962L18.2486 9.01679C18.4345 8.93739 18.5929 8.80517 18.7043 8.63656C18.8156 8.46795 18.875 8.27034 18.875 8.0683C18.875 7.86626 18.8156 7.66869 18.7043 7.50008C18.5929 7.33146 18.4345 7.19925 18.2486 7.11985L2.50856 1.19194C2.32466 1.12183 2.12449 1.1064 1.932 1.14751C1.73952 1.18862 1.56296 1.28453 1.42378 1.42364C1.2846 1.56276 1.18865 1.73916 1.14752 1.93155C1.10639 2.12395 1.12183 2.32413 1.19197 2.50795L7.12266 18.2406C7.20148 18.4295 7.33475 18.5907 7.50549 18.7036C7.67623 18.8166 7.87672 18.8762 8.08147 18.875C8.28622 18.8737 8.48596 18.8116 8.65528 18.6965C8.8246 18.5814 8.95585 18.4186 9.03232 18.2287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarToolsActive);
export default __webpack_public_path__ + "static/media/navbar-tools-active.184b5acab36b5297a4327adfe3612b34.svg";
export { ForwardRef as ReactComponent };